// import React from "react";
// import HeaderStyles from "./HeaderNew.module.css";
// import { Button, Image } from "react-bootstrap";
// import LikedIn from "../../assets/mobile/header/linkedIn.png";

// import useMediaQuery from "services/useMediaQuery";
// import HeaderSlideshow from "../Header/HeaderSlideshow/Header-Slideshow";
// import textLogo from "../../assets/logo-text.png";
// import QuoteOne from "Components/Quote/Quote";
// import bioImage from "../../assets/mobile/header/biologic-coordinator-icon.jpg";
// import teachImage from "../../assets/mobile/header/office-training-icon.jpg";
// import servicesImage from "../../assets/mobile/header/support-resources-icon.jpg";

// const HeaderDesktop = () => {
//   const matchedDesktop = useMediaQuery("(min-width: 728px)");

//   const mainContainer = HeaderStyles.mainContainer;
//   const logo = HeaderStyles.logo;
//   const titleContainerDesktop = HeaderStyles.titleContainerDesktop;
//   const titleDivider = HeaderStyles.titleDivider;
//   const slideshowContainer = HeaderStyles.slideshowContainer;
//   const socialContainer = HeaderStyles.socialContainer;
//   const link = HeaderStyles.link;
//   const contentContainer = HeaderStyles.contentContainer;
//   const introContainerDesktop = HeaderStyles.introContainerDesktop;
//   const scheduleButton = HeaderStyles.scheduleButton;
//   const reviewsContainer = HeaderStyles.reviewsContainer;
//   const slogan = HeaderStyles.slogan;
//   const desktopBgImage = HeaderStyles.desktopBgImage;
//   const divider = HeaderStyles.divider;
//   const logoImg = HeaderStyles.logoImg;
//   const logoDiv = HeaderStyles.logoDiv;
//   const mainTitle = HeaderStyles.mainTitle;
//   const subTitle = HeaderStyles.subTitle;
//   const contentParagraph = HeaderStyles.contentParagraph;
//   const headerImg = HeaderStyles.headerImg;
//   const contentDiv = HeaderStyles.contentDiv;
//   const contentDivSelector = HeaderStyles.contentDivSelector;

//   const url =
//     "https://www.linkedin.com/posts/brandis-boyd-cooper-cma-cdt-b534431a5_access-activity-7115025415395545088-CpSG?utm_source=share&utm_medium=member_android&fbclid=IwAR0kEDt7lFxUzC2evdHFfIzwJjUubZDA_oANCDtKFaKEL6FCVAKWEqMpTi4";

//   return (
//     <>
//       {matchedDesktop && (
//         <main className={mainContainer}>
//           <span className={desktopBgImage}></span>
//           <span className={socialContainer}>
//             <a href={url}>
//               <Image src={LikedIn} className={link} />
//             </a>{" "}
//           </span>
//           <section className={slideshowContainer}>
//             {/* <HeaderSlideshow /> */}
//           </section>

//           <section>
//             <div className={logo}></div>

//             <div className={introContainerDesktop}>
//               <div>
//                 <h3>Welcome to</h3>
//                 <div className={logoDiv}>
//                   <Image className={logoImg} src={textLogo} alt="logo" />
//                 </div>
//               </div>
//               <span className={titleDivider} />
//               <div
//                 style={{
//                   padding: ".5rem 1rem 1rem 1rem",
//                 }}
//               >
//                 <p className={slogan}>DESIGNED WITH SPECIALTY MEDS IN MIND!</p>
//                 <div className={contentDiv}>
//                   <div>
//                     <p className={mainTitle}>Biologic Coordinator Services</p>
//                     <Image
//                       className={headerImg}
//                       src={bioImage}
//                       alt={"biologic-coordinator-icon"}
//                     />
//                     <p className={contentParagraph}>
//                       Managing prior authorizations, appeals, and patient
//                       communication to ensure seamless access to medications.
//                     </p>
//                   </div>
//                   <div>
//                     <p className={mainTitle}>Office Education</p>
//                     <Image
//                       className={headerImg}
//                       src={teachImage}
//                       alt={"office-training-icon"}
//                     />
//                     <p className={contentParagraph}>
//                       Customized in-office training to improve medication
//                       management, enhance staff proficiency, and streamline
//                       patient care
//                     </p>
//                   </div>
//                   <div>
//                     <p className={mainTitle}>Support and Resources </p>
//                     <Image
//                       className={headerImg}
//                       src={servicesImage}
//                       alt={"support-resources-icon"}
//                     />
//                     <p className={contentParagraph}>
//                       Access to up-to-date information, tools, and templates to
//                       assist with documentation and staying informed on industry
//                       developments.
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             {/* might be a moving slideshow? */}
//             <div className={reviewsContainer}>
//               <h4>
//                 <div
//                   style={{
//                     display: "inline-block",
//                     position: "relative",
//                     top: "-8px",
//                   }}
//                 >
//                   <QuoteOne />
//                 </div>
//                 <b>Brandis is the best biologic coordinator in the game!</b>
//                 <div
//                   style={{
//                     display: "inline-block",
//                     rotate: "180deg",
//                     position: "relative",
//                     top: "3px",
//                   }}
//                 >
//                   <QuoteOne />
//                 </div>
//               </h4>

//               <p style={{ textAlign: "left", margin: "0 0 0 .8rem" }}>
//                 -- Dr.Sklar
//               </p>
//             </div>
//             <div style={{ textAlign: "center" }}>
//               <Button href="/#contact" className={scheduleButton}>
//                 BOOK A CONSULTATION TODAY
//               </Button>
//             </div>
//           </section>
//           <section className={divider}></section>
//         </main>
//       )}
//     </>
//   );
// };

// export default HeaderDesktop;

// # Modern Desktop Header Redesign for BioMazze

// ## Updated `HeaderDesktop.js`

import React from "react";
import HeaderStyles from "./HeaderNew2026.module.css";
import { Button, Image } from "react-bootstrap";
import LikedIn from "../../assets/mobile/header/linkedIn.png";

import useMediaQuery from "services/useMediaQuery";
import textLogo from "../../assets/logo-text.png";
// import QuoteOne from "Components/Quote/Quote";
import bioImage from "../../assets/desktop/header/icon-1.png";
import teachImage from "../../assets/desktop/header/icon-2.png";
import servicesImage from "../../assets/desktop/header/icon-3.png";

const HeaderDesktop = () => {
  const matchedDesktop = useMediaQuery("(min-width: 728px)");

  const {
    mainContainer,
    socialContainer,
    link,
    desktopHero,
    heroOverlay,
    heroContent,
    logoImg,
    slogan,
    modernSubtext,
    modernGrid,
    modernCard,
    modernIcon,
    modernTitle,
    modernText,
    scheduleButton,
    reviewBar,
  } = HeaderStyles;

  const url =
    "https://www.linkedin.com/posts/brandis-boyd-cooper-cma-cdt-b534431a5_access-activity-7115025415395545088-CpSG?utm_source=share&utm_medium=member_android&fbclid=IwAR0kEDt7lFxUzC2evdHFfIzwJjUubZDA_oANCDtKFaKEL6FCVAKWEqMpTi4";

  return (
    <>
      {matchedDesktop && (
        <main className={mainContainer}>
          <section className={desktopHero}>
            <div className={heroOverlay}></div>

            <span className={socialContainer}>
              <a href={url}>
                <Image src={LikedIn} className={link} />
              </a>
            </span>

            <div className={heroContent}>
              <Image className={logoImg} src={textLogo} alt="logo" />

              <p className={modernSubtext}>
                Training specialty practices to simplify biologic coordination,
                streamline patient access, & improve office workflows through
                hands-on education & support.
              </p>

              <div className={modernGrid}>
                <div className={modernCard}>
                  <div>
                    <Image
                      className={modernIcon}
                      src={bioImage}
                      alt="Biologic Coordinator"
                    />
                  </div>
                  <div>
                    <p className={modernTitle}>Biologic Coordination</p>
                    <p className={slogan}>
                      DESIGNED WITH SPECIALTY MEDS IN MIND
                    </p>
                    <p className={modernText}>
                      {/* Prior authorizations, appeals, patient communication, and
                      medication access management handled with precision. */}
                      • Prior authorizations and insurance submissions <br /> •
                      Appeals and denial resolution support <br /> • Patient
                      communication and follow-up <br /> • Medication access and
                      treatment coordination <br />• Pharmacy and manufacturer
                      collaboration <br />• Streamlined workflows for specialty
                      practices <br />• Compassionate, detail-oriented patient
                      support
                    </p>
                  </div>
                </div>

                <div className={modernCard}>
                  <div>
                    <Image
                      className={modernIcon}
                      src={teachImage}
                      alt="Office Training"
                    />
                  </div>

                  <div>
                    <p className={modernTitle}>Office Education</p>
                    <p className={modernText}>
                      • Customized biologic workflow training for providers and
                      staff
                      <br />
                      • Prior authorization and medication access education
                      <br />
                      • Staff guidance for improving office efficiency and
                      communication
                      <br />
                      • Real-world biologic coordination strategies and best
                      practices
                      <br />
                      • Support for streamlining patient onboarding and
                      follow-up
                      <br />• Training designed to improve patient care and
                      treatment outcomes
                    </p>
                  </div>
                </div>

                <div className={modernCard}>
                  <div>
                    <Image
                      className={modernIcon}
                      src={servicesImage}
                      alt="Support Resources"
                    />
                  </div>
                  <div>
                    {" "}
                    <p className={modernTitle}>Resources & Support</p>
                    <p className={modernText}>
                      • Access helpful biologic coordination tools and resources
                      <br />
                      • Downloadable templates and workflow support materials
                      <br />
                      • Industry updates and medication access guidance
                      <br />
                      • Assistance navigating specialty medication processes
                      <br />
                      • Resources designed to improve office efficiency and
                      communication
                      <br />• Ongoing support for providers, staff, and patient
                      coordination
                    </p>
                  </div>
                </div>
              </div>

              <div style={{ textAlign: "center" }}>
                <Button href="/#contact" className={scheduleButton}>
                  BOOK A CONSULTATION
                </Button>
              </div>

              <div className={reviewBar}>
                <h4>
                  {/* <div><QuoteOne /></div> */}
                  <b>
                    "Brandis is an asset to every office, provider and patient
                    she serves."
                  </b>
                  {/* <QuoteOne /> */}
                </h4>

                <p>— Pharmaceutical Representative</p>
              </div>
            </div>
          </section>
        </main>
      )}
    </>
  );
};

export default HeaderDesktop;
